import React, { useState } from "react";

import "./component.css";

const initialFoodItems = [
  {
    title: "Sambar Dosa",
    price: "₹ 5,000/-",
    category: "Food",
    img: "/image/food.png",
    quantity: 1,
    plate: "5 plate",
    waiting: "65 minutes",
  },
  {
    title: "Idli Vada",
    price: "₹ 5,000/-",
    category: "Food",
    img: "/image/food.png",
    quantity: 1,
    plate: "5 plate",
    waiting: "65 minutes",
  },
  {
    title: "Paneer Roll",
    price: "₹ 5,000/-",
    category: "Food",
    img: "/image/food.png",
    quantity: 1,
    plate: "5 plate",
    waiting: "65 minutes",
  },
  {
    title: "Paneer Roll",
    price: "₹ 5,000/-",
    category: "Food",
    img: "/image/food.png",
    quantity: 1,
    plate: "5 plate",
    waiting: "65 minutes",
  },
  {
    title: "Paneer Roll",
    price: "₹ 5,000/-",
    category: "Food",
    img: "/image/food.png",
    quantity: 1,
    plate: "5 plate",
    waiting: "65 minutes",
  },
];

export default function FoodGridMobileOnly() {
  const [foodItems] = useState(initialFoodItems);

  return (
    <div style={{ padding: "0 5px", backgroundColor: "#F4F5F7" }}>
      <div id="myappcrud" className="container py-3 d-block d-md-none">
        <h5 className="orders-title">Orders</h5>
        <div className="card-box  rounded  p-3">
          {foodItems.map((item, idx) => (
            <div key={idx} className="d-flex align-items-start mb-3">
              <img
                src={item.img}
                alt={item.title}
                className="food-image rounded img-fluid me-2"
                style={{ width: "90px", height: "90px", objectFit: "cover" }}
              />
              <div className="flex-grow-1">
                <h6 className="mb-1 fw-semibold">{item.title}</h6>
                <div className="text-muted small">{item.plate}</div>
                <div className="text-muted small">{item.waiting}</div>
              </div>
              <div className=" ms-2  text-white rounded d-flex align-items-center px-2">
                <div className="text-muted small">{item.price}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
